<template>
  <!-- 早番遅番 -->
  <template v-if="shinseis.hayabanOsoban.length > 0">
    <template v-for="item in shinseis.hayabanOsoban" :key="item.id">
      <p class="shinsei-title no-link">{{ item.notes }}</p>
    </template>
  </template>

  <!-- 公休 -->
  <template v-if="shinseis.koukyuu.length > 0">
    <template v-for="item in shinseis.koukyuu" :key="item.id">
      <p class="shinsei-title no-link" :class="{
    'cancel-title koukyuu': item.syounin_status_type == OptionConst.SYOUNIN_STATUS.CANCEL && authStore.hasPermission(PermissionConst.KINMU_EDIT),
    'hide-cancel-title': item.syounin_status_type == OptionConst.SYOUNIN_STATUS.CANCEL && !authStore.hasPermission(PermissionConst.KINMU_EDIT),
  }">{{ item.notes }}</p>
    </template>
  </template>

  <!-- 時間外 -->
  <template v-if="shinseis.jikangai.length > 0">
    <template v-for="item in shinseis.jikangai" :key="item.id">
      <p class="shinsei-title" :class="{
    'applying-title': item.syounin_status_type == OptionConst.SYOUNIN_STATUS.WAIT,
    'cancel-title': item.syounin_status_type == OptionConst.SYOUNIN_STATUS.CANCEL,
  }" @click.native="clickShinsei(item)">時間外 </p>
    </template>
  </template>

  <!-- 休憩未取得 -->
  <template v-if="shinseis.kyuukei.length > 0">
    <template v-for="item in shinseis.kyuukei" :key="item.id">
      <p class="shinsei-title" :class="{
    'applying-title': item.syounin_status_type == OptionConst.SYOUNIN_STATUS.WAIT,
    'cancel-title': item.syounin_status_type == OptionConst.SYOUNIN_STATUS.CANCEL,
  }" @click.native="clickShinsei(item)">休憩未取得</p>
    </template>
  </template>

  <!-- 振休・振出 -->
  <template v-if="shinseis.furikyuu.length > 0">
    <template v-for="item in shinseis.furikyuu" :key="item.id">
      <p class="shinsei-title" :class="{
    'applying-title': item.syounin_status_type == OptionConst.SYOUNIN_STATUS.WAIT,
    'cancel-title': item.syounin_status_type == OptionConst.SYOUNIN_STATUS.CANCEL,
  }" @click.native="clickShinsei(item)">{{ item.notes }} </p>
    </template>
  </template>

  <!-- 有給 -->
  <template v-if="shinseis.yuukyuu.length > 0">
    <template v-for="item in shinseis.yuukyuu" :key="item.id">
      <p class="shinsei-title" :class="{
    'applying-title': item.syounin_status_type == OptionConst.SYOUNIN_STATUS.WAIT,
    'cancel-title': item.syounin_status_type == OptionConst.SYOUNIN_STATUS.CANCEL,
  }" @click.native="clickShinsei(item)">{{ item.notes }} </p>
    </template>
  </template>

  <!-- 欠勤 -->
  <template v-if="shinseis.kekkin.length > 0">
    <template v-for="item in shinseis.kekkin" :key="item.id">
      <p class="shinsei-title" :class="{
    'applying-title': item.syounin_status_type == OptionConst.SYOUNIN_STATUS.WAIT,
    'cancel-title': item.syounin_status_type == OptionConst.SYOUNIN_STATUS.CANCEL,
  }" @click.native="clickShinsei(item)">{{ item.notes }} </p>
    </template>
  </template>

  <!-- 早退 -->
  <template v-if="shinseis.soutai.length > 0">
    <template v-for="item in shinseis.soutai" :key="item.id">
      <p class="shinsei-title" :class="{
    'applying-title': item.syounin_status_type == OptionConst.SYOUNIN_STATUS.WAIT,
    'cancel-title': item.syounin_status_type == OptionConst.SYOUNIN_STATUS.CANCEL,
  }" @click.native="clickShinsei(item)">{{ item.notes }} </p>
    </template>
  </template>

  <!-- 遅刻 -->
  <template v-if="shinseis.chikoku.length > 0">
    <template v-for="item in shinseis.chikoku" :key="item.id">
      <p class="shinsei-title" :class="{
    'applying-title': item.syounin_status_type == OptionConst.SYOUNIN_STATUS.WAIT,
    'cancel-title': item.syounin_status_type == OptionConst.SYOUNIN_STATUS.CANCEL,
  }" @click.native="clickShinsei(item)">{{ item.notes }} </p>
    </template>
  </template>

  <!-- 日直 -->
  <template v-if="shinseis.nittyoku.length > 0">
    <template v-for="item in shinseis.nittyoku" :key="item.id">
      <p class="shinsei-title" :class="{
    'applying-title': item.syounin_status_type == OptionConst.SYOUNIN_STATUS.WAIT,
    'cancel-title': item.syounin_status_type == OptionConst.SYOUNIN_STATUS.CANCEL,
  }" @click.native="clickShinsei(item)">{{ item.notes }} </p>
    </template>
  </template>

  <!-- 忌引き -->
  <template v-if="shinseis.kibiki.length > 0">
    <template v-for="item in shinseis.kibiki" :key="item.id">
      <p class="shinsei-title" :class="{
    'applying-title': item.syounin_status_type == OptionConst.SYOUNIN_STATUS.WAIT,
    'cancel-title': item.syounin_status_type == OptionConst.SYOUNIN_STATUS.CANCEL,
  }" @click.native="clickShinsei(item)">{{ item.notes }} </p>
    </template>
  </template>

  <!-- 半日補正（異動届） -->
  <template v-if="shinseis.hannichiHosei.length > 0">
    <template v-for="item in shinseis.hannichiHosei" :key="item.id">
      <p class="shinsei-title" :class="{
    'applying-title': item.syounin_status_type == OptionConst.SYOUNIN_STATUS.WAIT,
    'cancel-title': item.syounin_status_type == OptionConst.SYOUNIN_STATUS.CANCEL,
  }" @click.native="clickShinsei(item)">{{ item.notes }} </p>
    </template>
  </template>

  <!-- 打刻修正 -->
  <template v-if="shinseis.syuusei.length > 0">
    <template v-for="item in shinseis.syuusei" :key="item.id">
      <p class="shinsei-title" :class="{
    'applying-title': item.syounin_status_type == OptionConst.SYOUNIN_STATUS.WAIT,
    'cancel-title': item.syounin_status_type == OptionConst.SYOUNIN_STATUS.CANCEL,
  }" @click.native="clickShinsei(item)">{{ item.notes }} </p>
    </template>
  </template>
</template>

<script lang="ts">
import { defineComponent } from "vue";
import { DakokuDataFull, DakokuInfoShinsei, ShinseiInfo } from "@/types/Dakoku";
import OptionConst from "@/const/Option";
import { RouterConst } from '@/const/Router'
import { useAuthStore } from "@/store/auth";
import { PermissionConst } from "@/const/Permission";
import { useRouter } from "vue-router";

export default defineComponent({
  props: {
    shinseis: {
      type: Object as () => DakokuInfoShinsei,
      default: null
    },
    kinmu: {
      type: Object as () => DakokuDataFull | null,
      default: null
    },
    userId: {
      type: Number as () => number
    },
    year: {
      type: Number as () => number
    },
    month: {
      type: Number as () => number
    }
  },
  emits: ['clickShinsei'],
  setup(props, context) {
    const authStore = useAuthStore()
    const router = useRouter()
    const currentPage = router.currentRoute.value.name;
    const clickShinsei = (async (shinsei: ShinseiInfo) => {
      context.emit('clickShinsei', props.userId) // 申請をクリックしたときに、親コンポーネントに対象ユーザーIDを返す（MEDICA_AS-1226）

      // タイムシートに戻った際に元の就業場所、年月に戻るようにするための情報（MEDICA_AS-1253）
      router.push({
        name: RouterConst.SHINSEI_DETAIL,
        params: { id: shinsei.id },
        query: {
          from: currentPage?.toString(),
          year: props.year,
          month: props.month,
          syuugyou_basyo_id: shinsei.mst_syuugyou_basyo_id,
          koyou_keiyaku_id: shinsei.koyou_keiyaku_id,
          user_id: shinsei.user_id
        }
      })
    });

    return {
      OptionConst: OptionConst,
      RouterConst: RouterConst,
      clickShinsei,
      authStore,
      PermissionConst
    };
  },
  components: {
  }
});
</script>

<style lang="scss" scoped>
@import '@scss/components/shinsei-title.scss';
</style>
